import BTable from 'react-bootstrap/Table';
import {Column, usePagination, useSortBy, useTable} from 'react-table';
import ReactTablePagination from '../ReactTablePagination';

interface MyAreaTableProps<T extends object> {
    columns: Column<T>[]
    data: T[]
};

/**
 * Generisches tabellarisches Listing
 *
 * @constructor
 */
const MyAreaTable = <T extends object>({ columns, data }: MyAreaTableProps<T>): JSX.Element => {

    // Tabellen-Props und State initialisieren
    const {
        getTableProps,
        headerGroups,
        prepareRow,
        page,
        canPreviousPage,
        canNextPage,
        pageOptions,
        pageCount,
        gotoPage,
        nextPage,
        previousPage,
        setPageSize,
        state: { pageIndex, pageSize }
    } = useTable(
        {
            columns,
            data,
            initialState: { pageIndex: 0, pageSize: 5 }
        },
        useSortBy,
        usePagination
    );

    return (
        <>
            <BTable bordered hover size="sm" {...getTableProps()}>
                <thead>
                    {headerGroups.map(headerGroup => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map(column => (
                                <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                                    {column.render('Header')}
                                    <span>
                                        {column.canSort && (
                                            column.isSorted
                                                ? column.isSortedDesc
                                                    ? <i className="fa fa-sort-down" />
                                                    : <i className="fa fa-sort-up" />
                                                : <i className="fa fa-sort" />
                                        )
                                        }
                                    </span>
                                </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody>
                    {page.map((row, i) => {
                        prepareRow(row)
                        return (
                            <tr {...row.getRowProps()}>
                                {row.cells.map(cell => (
                                    <td {...cell.getCellProps()}>
                                        {cell.render('Cell')}
                                    </td>
                                ))}
                            </tr>
                        )
                    })}
                </tbody>
            </BTable>
            <ReactTablePagination
                page={page}
                pageCount={pageCount}
                pageOptions={pageOptions}
                canPreviousPage={canPreviousPage}
                canNextPage={canNextPage}
                gotoPage={gotoPage}
                previousPage={previousPage}
                nextPage={nextPage}
                setPageSize={setPageSize}
                pageIndex={pageIndex}
                pageSize={pageSize}
            />
        </>
    );
};

export default MyAreaTable;
